import { Alert, Box, LinearProgress } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import Section from './section';
import axios from 'axios';
import { OrganisationSettings } from '../../../interfaces/delivery-company/orders';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { emptyOrgSettings } from '../../../data/settings';
import LocationTrackingConfig from './location-tracking-config/location-tracking-config';

function LocationTracking() {
  const { config } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>();
  const [orgSettings, setOrgSettings] = useState<OrganisationSettings>(emptyOrgSettings);

  useEffect(() => {
    const fetchOrgSettings = async () => {
      try {
        const response = await axios.get<OrganisationSettings>(
          `${API_ENDPOINT}/api/v1/settings`,
          config
        );
        setOrgSettings(response.data);
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setError('Failed to load organisation settings: ' + e.message);
        } else {
          setError('Failed to load organisation settings');
        }
        console.log(e);
      }

      setLoading(false);
    };

    fetchOrgSettings();
  }, []);

  return (
    <Box>
      {loading ? (
        <LinearProgress />
      ) : (
        <>
          {error ? (
            <Alert severity="error">{error}</Alert>
          ) : (
            <Section title="Driver Location Tracking">
              <LocationTrackingConfig settings={orgSettings} />
            </Section>
          )}
        </>
      )}
    </Box>
  );
}

export default LocationTracking;




